// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconBell = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M12 2c-.711 0-1.286.559-1.286 1.25V4c-2.933.578-5.142 3.102-5.142 6.125v.734a7.4 7.4 0 0 1-1.949 4.985l-.297.324a1.23 1.23 0 0 0-.213 1.344c.205.449.667.738 1.173.738h15.429c.506 0 .964-.29 1.173-.738a1.22 1.22 0 0 0-.213-1.344l-.298-.324a7.4 7.4 0 0 1-1.948-4.985v-.734c0-3.023-2.21-5.547-5.143-6.125v-.75C13.286 2.559 12.71 2 12 2m1.82 19.27a2.47 2.47 0 0 0 .752-1.77H9.429c0 .664.269 1.3.751 1.77A2.6 2.6 0 0 0 12 22a2.6 2.6 0 0 0 1.82-.73'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconBell)
const Memo = memo(ForwardRef)
export default Memo
